module.exports = __webpack_public_path__ + "img/loading.a21746f5.gif";